// extracted by mini-css-extract-plugin
export default {"spinner":"App_spinner__h+vrd","appFallback":"App_appFallback__uLNWs","appFallbackContent":"App_appFallbackContent__NkKcF","fallbackFunctions":"App_fallbackFunctions__gZ5I1"};